<template>
    <div
        aria-labelledby="property-hero-images"
        class="mx-auto max-w-full w-full overflow-hidden relative h-full max-h-96"
    >
        <ImageLoader>
            <template #image>
                <img
                    v-if="property.image_location"
                    :src="property.image_location"
                    :alt="property.name"
                    class="w-full h-full object-cover object-center rounded-lg"
                />
            </template>
            <template #error>
                <div
                    class="min-w-52 h-52 rounded-lg object-cover flex items-center justify-center text-center flex-col bg-slate-200 text-slate-400"
                >
                    <Icon icon="no-image" />
                </div>
            </template>
        </ImageLoader>
        <div
            class="h-9 p-2 bg-white bg-opacity-90 rounded justify-center items-center inline-flex absolute bottom-2 right-2"
        >
            <img
                :src="`/images/${pointsProgram?.image}`"
                class="max-w-[68px] h-auto max-h-7"
            />
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useHotelsStore } from '@/store/hotels';
import ImageLoader from '@/components/ui/image-loader/image-loader.vue';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    components: { Icon, ImageLoader },
    computed: {
        ...mapState(useHotelsStore, ['loading', 'property', 'pointsProgram']),
    },
    methods: {
        ...mapActions(useHotelsStore, ['setLoading']),
    },
};
</script>
